import React, { useState } from 'react';
import { 
  FaHotel, 
  FaUser, 
  FaEnvelope, 
  FaPhone, 
  FaCalendarAlt, 
  FaPaperPlane,
  FaCheckCircle,
  FaStar,
  FaMapMarkerAlt,
  FaRupeeSign,
  FaBed,
  FaUsers,
  FaInfoCircle,
  FaArrowRight
} from 'react-icons/fa';
import { GiKnifeFork, GiBed } from 'react-icons/gi';
import { MdWifi, MdPool, MdLocalParking, MdRoomService } from 'react-icons/md';
import { IoIosFitness } from 'react-icons/io';
import '../style.css';

const HotelBooking = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    checkIn: '',
    checkOut: '',
    guests: '1',
    rooms: '1',
    roomType: 'standard',
    details: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const roomTypes = [
    { id: 'standard', name: 'Standard', price: '₹1,999', features: ['AC', 'TV', 'WiFi'] },
    { id: 'deluxe', name: 'Deluxe', price: '₹2,999', features: ['AC', 'TV', 'WiFi', 'Mini Bar'] },
    { id: 'suite', name: 'Suite', price: '₹4,499', features: ['AC', 'TV', 'WiFi', 'Mini Bar', 'Living Area'] },
    { id: 'family', name: 'Family', price: '₹3,499', features: ['AC', 'TV', 'WiFi', '2 Bedrooms'] }
  ];

  const hotels = [
    {
      name: 'Taj Hotel',
      location: 'Delhi',
      rating: 4.8,
      price: '₹5000',
      image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80'
    },
    {
      name: 'Oberoi Hotel',
      location: 'Mumbai',
      rating: 4.9,
      price: '₹6000',
      image: 'https://www.kayak.com/news/wp-content/uploads/sites/19/2023/10/THEME_STAYS_MOTEL_GettyImages-136802528-2562x2050.jpg'
    },
    {
      name: 'Radisson Blu',
      location: 'Bangalore',
      rating: 4.7,
      price: '₹7000',
      image: 'https://tse1.mm.bing.net/th/id/OIP.5h1E1kztVWq1yKNf95ryNAHaEP?rs=1&pid=ImgDetMain&o=7&rm=3'
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Booking submitted:', formData);
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 3000);
  };

  return (
    <div className="hotel-booking-page brown-theme">
      {/* Header */}
      <div className="booking-header">
        <div className="header-content">
          <h1>
            <FaHotel className="header-icon" />
            Hotel Booking
          </h1>
          <p className="tagline">Shree Balaji Travel - Find Your Perfect Stay</p>
        </div>
      </div>

      <div className="booking-container">
        {/* Left Side - Form */}
        <div className="booking-left">
          {/* Success Message */}
          {isSubmitted && (
            <div className="success-card">
              <FaCheckCircle className="success-icon" />
              <div>
                <h3>Booking Request Sent!</h3>
                <p>We'll contact you shortly.</p>
              </div>
            </div>
          )}

          {/* Booking Form */}
          <div className="booking-card">
            <h2 className="card-title">
              <FaUser className="title-icon" />
              Book Your Hotel
            </h2>
            
            <form onSubmit={handleSubmit} className="booking-form">
              <div className="form-row">
                <div className="input-group">
                  <label>
                    <FaUser className="input-icon" />
                    Your Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="input-group">
                  <label>
                    <FaEnvelope className="input-icon" />
                    Email ID
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <label>
                    <FaPhone className="input-icon" />
                    Contact No
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter Number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="input-group">
                  <label>
                    <FaUsers className="input-icon" />
                    Guests
                  </label>
                  <select
                    name="guests"
                    value={formData.guests}
                    onChange={handleInputChange}
                  >
                    <option value="1">1 Guest</option>
                    <option value="2">2 Guests</option>
                    <option value="3">3 Guests</option>
                    <option value="4">4 Guests</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <label>
                    <FaCalendarAlt className="input-icon" />
                    Check In
                  </label>
                  <input
                    type="date"
                    name="checkIn"
                    value={formData.checkIn}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="input-group">
                  <label>
                    <FaCalendarAlt className="input-icon" />
                    Check Out
                  </label>
                  <input
                    type="date"
                    name="checkOut"
                    value={formData.checkOut}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <label>
                    <FaBed className="input-icon" />
                    Rooms
                  </label>
                  <select
                    name="rooms"
                    value={formData.rooms}
                    onChange={handleInputChange}
                  >
                    <option value="1">1 Room</option>
                    <option value="2">2 Rooms</option>
                    <option value="3">3 Rooms</option>
                  </select>
                </div>

                <div className="input-group">
                  <label>
                    <FaStar className="input-icon" />
                    Room Type
                  </label>
                  <select
                    name="roomType"
                    value={formData.roomType}
                    onChange={handleInputChange}
                  >
                    {roomTypes.map(room => (
                      <option key={room.id} value={room.id}>
                        {room.name} - {room.price}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="input-group">
                <label>
                  <FaInfoCircle className="input-icon" />
                  Details
                </label>
                <textarea
                  name="details"
                  placeholder="Enter Details"
                  value={formData.details}
                  onChange={handleInputChange}
                  rows="3"
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                <FaPaperPlane /> Submit
              </button>
            </form>
          </div>

          {/* Popular Hotels */}
          <div className="hotels-card">
            <h2 className="card-title">
              <FaStar className="title-icon" />
              Popular Hotels
            </h2>
            <div className="hotels-grid">
              {hotels.map((hotel, index) => (
                <div key={index} className="hotel-item">
                  <img src={hotel.image} alt={hotel.name} />
                  <div className="hotel-info">
                    <h3>{hotel.name}</h3>
                    <p className="hotel-location">
                      <FaMapMarkerAlt /> {hotel.location}
                    </p>
                    <div className="hotel-footer">
                      <div className="rating">
                        <FaStar /> {hotel.rating}
                      </div>
                      <div className="price">
                        <FaRupeeSign /> {hotel.price}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Side - Info */}
        <div className="booking-right">
          {/* Room Types */}
          <div className="rooms-card">
            <h2 className="card-title">
              <FaBed className="title-icon" />
              Room Types
            </h2>
            <div className="rooms-list">
              {roomTypes.map(room => (
                <div 
                  key={room.id} 
                  className={`room-item ${formData.roomType === room.id ? 'selected' : ''}`}
                  onClick={() => setFormData({...formData, roomType: room.id})}
                >
                  <div className="room-header">
                    <h3>{room.name}</h3>
                    <span className="room-price">{room.price}</span>
                  </div>
                  <div className="room-features">
                    {room.features.map((feature, idx) => (
                      <span key={idx} className="feature-tag">{feature}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Features */}
          <div className="features-card">
            <h2 className="card-title">
              <FaCheckCircle className="title-icon" />
              Hotel Features
            </h2>
            <div className="features-grid">
              <div className="feature">
                <MdWifi className="feature-icon" />
                <span>Free WiFi</span>
              </div>
              <div className="feature">
                <GiKnifeFork className="feature-icon" />
                <span>Restaurant</span>
              </div>
              <div className="feature">
                <MdPool className="feature-icon" />
                <span>Swimming Pool</span>
              </div>
              <div className="feature">
                <IoIosFitness className="feature-icon" />
                <span>Fitness Center</span>
              </div>
              <div className="feature">
                <MdLocalParking className="feature-icon" />
                <span>Free Parking</span>
              </div>
              <div className="feature">
                <MdRoomService className="feature-icon" />
                <span>Room Service</span>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className="contact-card">
            <h2 className="card-title">
              <FaPhone className="title-icon" />
              Contact Us
            </h2>
            <div className="contact-info">
              <p className="phone">+91 94157 99879</p>
              <p className="email">info@balajitravel.com</p>
              <button className="call-btn">
                <FaPhone /> Call Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelBooking;